import {SetUserName} from "../../../redux/ConnectorWrapper";

export function ResetUserDetails(props) {
    SetUserName(props, null);
}